/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S5_P1Inputs */

const tr_mesafeli_s5_p1 = /** @type {(inputs: Mesafeli_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet bedelleri, Müşteri'nin seçtiği Abonelik Planı'na göre Platform üzerinde KDV dahil ilan edilen tarifeden tahsil edilir. Tüm bedeller Türk Lirası (TL) cinsindendir.`)
};

const en_mesafeli_s5_p1 = /** @type {(inputs: Mesafeli_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service fees are charged according to the Subscription Plan chosen by the Customer, at the tariff announced on the Platform including KDV. All amounts are in Turkish Lira (TL).`)
};

const de_mesafeli_s5_p1 = /** @type {(inputs: Mesafeli_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Entgelte werden nach dem vom Kunden gewählten Abonnementplan zu dem auf der Plattform inklusive KDV veröffentlichten Tarif erhoben. Alle Beträge lauten auf Türkische Lira (TL).`)
};

const ru_mesafeli_s5_p1 = /** @type {(inputs: Mesafeli_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стоимость услуг взимается согласно выбранному Клиентом Плану подписки по тарифу, объявленному на Платформе с учётом KDV. Все суммы указаны в турецких лирах (TL).`)
};

/**
* | output |
* | --- |
* | "Service fees are charged according to the Subscription Plan chosen by the Customer, at the tariff announced on the Platform including KDV. All amounts are in..." |
*
* @param {Mesafeli_S5_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s5_p1 = /** @type {((inputs?: Mesafeli_S5_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S5_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s5_p1(inputs)
	if (locale === "de") return de_mesafeli_s5_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s5_p1(inputs)
	return tr_mesafeli_s5_p1(inputs)
});